import { useContext } from "react";
import { TypographyH2, TypographyP } from "./Typography";
import { LanguageContext } from "./languageContext";
import { HeaderIds } from "src/helpers/uiConstants";

export default function WhatsNext() {
  const { translate } = useContext(LanguageContext);
  return (
    <div className="space-y-4 mb-10">
      <TypographyH2 id={HeaderIds.whatsNextHeader} textId="whatsNext" />
      <TypographyP textId="whatsNextDescription" />
      <TypographyP textId="whatsNextDescription2" />
      <p>
        {translate("whatsNextDescription3")}{" "}
        <a href="https://sfmta.com" className="text-destructive underline">
          {translate("projectNewsletter")}
        </a>
      </p>
    </div>
  );
}
